/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Tab } from './Tab';

export namespace Tabs {
  interface TabConfig {
    id: string;
    label: string;
    count?: number;
    onClick: () => void;
  }
  export interface Props {
    tabsConfig: TabConfig[];
    activeTab?: string;
  }
}

const styles = StyleSheet.create({
  tabsWrapper: {
    display: 'flex',
  },
  tabWrapper: {
    ':not(:last-child)': {
      paddingRight: 20,
    },
  },
});
export const Tabs: React.FC<Tabs.Props> = ({ activeTab, tabsConfig }) => {
  return (
    <div className={css(styles.tabsWrapper)}>
      {tabsConfig.map(tabConfig => {
        return (
          <div key={tabConfig.id} className={css(styles.tabWrapper)}>
            <Tab {...tabConfig} active={activeTab === tabConfig.id} />
          </div>
        );
      })}
    </div>
  );
};
